"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var _ = __importStar(require("lodash"));
var getTemplateTile = function (createUi, noop, getTemplateUnit) {
    var getTemplateTile = function (_a) {
        var name = _a.name, id = _a.id, theme = _a.theme, active = _a.active, activeTemplate = _a.activeTemplate, templateList = _a.templateList, _b = _a.selectTemplate, selectTemplate = _b === void 0 ? noop : _b;
        var templateUiList = templateList.map(function (template, index) {
            return getTemplateUnit({
                template: template,
                theme: theme,
                projectId: template.projectId,
                active: template.projectId === activeTemplate,
                selectTemplate: function (_template) {
                    _.forEach(templateUiList, function (templateUi) {
                        templateUi.active = _template.projectId === templateUi.projectId;
                    });
                    return selectTemplate(_template, id);
                },
                index: index + 1,
            });
        });
        var ui = createUi(require("./TemplateTile.html"), {
            name: name,
            id: id,
            templateList: templateList,
            active: active,
            theme: theme,
            $show: false,
            icon: getIconUrl(name),
            templateUiList: templateUiList,
            templateWord: templateList.length === 1 ? "template" : "templates",
            selectFirstTemplate: function () {
                _.forEach(templateUiList, function (templateUi) {
                    templateUi.active = false;
                });
                return selectTemplate(templateList[0], id);
            },
            expand: function () {
                if (templateList.length === 1) {
                    return selectTemplate(templateList[0], id);
                }
                else {
                    return (ui.$show = !ui.$show);
                }
            },
        });
        return ui;
    };
    var getIconUrl = function (name) {
        return "/Assets/icons/templates/".concat(getIconName(name));
    };
    var getIconName = function (name) {
        switch (name) {
            case "Agenda":
            case "Meeting schedule":
            case "Program":
                return "meeting.svg";
            case "Announcement":
            case "Press release":
                return "press.svg";
            case "Brochure":
            case "Hiring":
            case "Job description":
            case "One pager":
            case "Resume":
                return "brochure.svg";
            case "Case study":
                return "case-study.svg";
            case "Contract":
                return "contract.svg";
            case "Invitation":
            case "Newsletter":
                return "newsletter.svg";
            case "Invoice":
            case "Proposal":
            case "Quote":
                return "quote.svg";
            case "Other":
            case "Presentation":
                return "presentation.svg";
            case "Report":
                return "report.svg";
        }
    };
    return getTemplateTile;
};
exports.default = getTemplateTile;
